import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ReactiveFormsModule} from '@angular/forms';
//import { HttpClientModule } from '@angular/common/http';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ForgotpasswordComponent } from './forgotpassword.component';
import { TextboxModule} from 'controls';
@NgModule({
  declarations: [ForgotpasswordComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    //HttpClientModule,
    NgxSpinnerModule,
    TextboxModule,
  ]
})
export class ForgotpasswordModule { }
